import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { GenerateCvService } from 'src/app/services/generate-cv/generate-cv.service';
import { PaymentService } from 'src/app/services/payment/payment.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CvDbService } from 'src/app/services/cv-db/cv-db.service';


@Component({
  selector: 'app-review-resume',
  templateUrl: './review-resume.component.html',
  styleUrls: ['./review-resume.component.css'],
})
export class ReviewResumeComponent implements OnInit {

  safeUrl?: SafeResourceUrl;

  base64: String = "";

 
  isPdfPurchased: boolean = false;
  isWordPurchased: boolean = false;
  // Used to show a loading state while checking purchase status
  loadingPurchaseStatus: boolean = true;
  userInfo?: any = JSON.parse(localStorage.getItem('userInfo') || '{}');

  constructor(private translate: TranslateService,
    private fb: FormBuilder,
    private generateCvService: GenerateCvService,
    private paymentService: PaymentService,
    private router: Router,
    private gtmService: GoogleTagManagerService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private sanitizer: DomSanitizer,
    private cvDbService: CvDbService){

  }
  async ngOnInit() {
    const data = await this.cvDbService.getAllPdfs();
   if(data.length > 0){
    this.base64 = data[0].image;
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      'data:image/png;base64,' + this.base64
    );
   }
   else{
    this.generateCvService.data$.subscribe(data => {
      this.base64 = data.image;
      this.cvDbService.savePdf(data);
    });
  // Prepare the image for safe display
  this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    'data:image/png;base64,' + this.base64
  );

   }
     
    // Check purchase status for both PDF and Word products
    const pdfKey = 'generate-cv-pdf';
    const wordKey = 'generate-cv-word';
    Promise.all([
      this.paymentService.checkIsProductPurchased(pdfKey),
      this.paymentService.checkIsProductPurchased(wordKey)
    ]).then(([pdfPurchased, wordPurchased]) => {
      this.isPdfPurchased = pdfPurchased;
      this.isWordPurchased = wordPurchased;
      this.loadingPurchaseStatus = false;
    });
  }
  
  onPrevious() {
      this.router.navigate(['/generatResumeSteps'], { queryParams: { step: 0 } });
  }

 
  goToPayment(productKey: string) {
    this.router.navigate(['/payment'], { state: { productKey: productKey }, queryParams: { productKey: productKey } });
  }

  // Download the file (PDF or Word) using the base64 data
  downloadFile(base64Data: string, filename: string, type: string) {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      const binaryData = this.base64ToArrayBuffer(base64Data);
      const blob = new Blob([binaryData], { type });
      const link = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(url);
      this.sendGoogleEvent('download cv');
    }
  }

  // Convert base64 string to ArrayBuffer for file download
  private base64ToArrayBuffer(base64: string): ArrayBuffer {
    let binaryString = '';
    if (typeof window !== 'undefined') {
      binaryString = window.atob(base64);
    }
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  // Send analytics events for downloads
  sendGoogleEvent(name: string) {
    this.googleAnalyticsService.event(name);
    this.gtmService.pushTag({
      event: 'customEvent',
      category: 'button',
      action: 'click',
      label: name,
    });
  }

  // Handle download button click for PDF or Word
  onDownload(type: 'pdf' | 'word') {
    // Here you should call your backend to get the file for the user
    // For now, just use the base64 image as a placeholder
    const filename = type === 'pdf' ? 'CV.pdf' : 'CV.docx';
    const mimeType = type === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    this.downloadFile(this.base64 as string, filename, mimeType);
  }
}
